export enum CalculateRoundKinds {
  /** 四捨五入 */
  RoundOff = 1,
  /** 切り上げ */
  RoundUp = 2,
  /** 切り捨て */
  RoundDown = 3,
}
